/**
 * Work types that are a call record (the call form, transcript on the Work itself) rather than an engagement:
 * a Care Coordination Call, or an Inbound Call linked with no task. Mirrors CALL_RECORD_TYPES in the backend's
 * system_work_types.py.
 */
export const CARE_COORDINATION_CALL = 'care_coordination_call'
export const INBOUND_CALL = 'inbound_call'
export const CALL_RECORD_TYPES = [CARE_COORDINATION_CALL, INBOUND_CALL]

export function isCallRecordType(name) {
  return CALL_RECORD_TYPES.includes(name)
}
